import * as React from "react";
const SvgRedirect = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    data-icon="1"
    {...props}
  >
    <path
      fill="#1F2328"
      fillRule="evenodd"
      d="M7.5 7.375a1.875 1.875 0 0 1 3.75 0v9.25a3.375 3.375 0 1 0 6.75 0v-4.814l1.22 1.22 1.06-1.061-3.03-3.03-3.03 3.03 1.06 1.06 1.22-1.22v4.815a1.875 1.875 0 0 1-3.75 0v-9.25a3.375 3.375 0 1 0-6.75 0V9.5H4V15h5.5V9.5h-2zM5.5 11v2.5H8V11z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgRedirect;
